module.exports = __webpack_public_path__ + "static/img/picc3.f6e8ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/picc3.png
// module id = sjqE
// module chunks = 0